import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Modelo } from '../../../comun/model/autos.model';
import { AutosBusquedaStoreService } from '../../services/store/autos-busqueda-store.service';
import { CaRadioButtonComponent, CaRadioGroupDirective } from '@global-front-components/ui/radio-button';
import { CaSelectComponent } from '@global-front-components/ui/select';
import { CaFormFieldComponent } from '@global-front-components/ui/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { CaCardComponent } from '@global-front-components/ui/card';

@Component({
	selector: 'app-modelos',
	standalone: true,
	imports: [
    CommonModule,
    CaCardComponent,
    CaRadioButtonComponent,
    CaFormFieldComponent,
    CaSelectComponent,
    CaRadioGroupDirective,
    TranslateModule
],
	templateUrl: './modelos.component.html',
	styleUrls: ['./modelos.component.scss']
})
export class ModelosComponent implements OnInit {	
	@ViewChild(CaSelectComponent)
	private selectModelos: CaSelectComponent;

	public modelosDestacados: Modelo[];
	public modelos: Modelo[];

	public modelosEnColumnas: any[][] = [];

	constructor(private autosStore: AutosBusquedaStoreService) { }

	ngOnInit(): void {
		this.autosStore.modelosDestacadosSubject$.subscribe({
			next: (modelosDestacados) => {
				this.modelosDestacados = modelosDestacados;
				this.modelosEnColumnas = this.getModelosEnColumnas();
			},
			error: (err) => console.error('Error recuperando modelos destacados:', err),
		});
		this.autosStore.modelosSubject$.subscribe({
			next: (modelos) => {
				this.modelos = modelos;		
				this.modelosEnColumnas = this.getModelosEnColumnas();			
			},
			error: (err) => console.error('Error recuperando modelos:', err),
		});
	}

	seleccionarModeloDestacado(event: any): void {
		const modelo: Modelo = event.value;
		this.selectModelos.writeValue(modelo.nombreModelo);
		this.seleccionarModelo(modelo.nombreModelo);
	}

	seleccionarModelo(nombreModelo: string): void {
		if (!nombreModelo) {
			return;
		}
		this.autosStore.setModeloSeleccionado(nombreModelo);
		this.autosStore.getVersiones();
	}

	getModelosEnColumnas(): any[][] {
		const filas = 4;
		const columnas = 3;
		const modelos: Modelo[] = 
			(this.modelosDestacados && this.modelosDestacados.length > 0)
			? this.modelosDestacados
			: this.modelos;

		if (modelos?.length > 0) {
			const result: any[][] = [];
			for (let col = 0; col < columnas; col++) {
				const columnaArr: any[] = [];
				for (let row = 0; row < filas; row++) {
					const index = col * filas + row;
					if (index < modelos.length) {
						columnaArr.push(modelos[index]);
					}
				}
				result.push(columnaArr);
			}
			return result;
		}
	}
}
